import { FC, PropsWithChildren } from "react";
import { LoadingOutlined } from "@ant-design/icons";
export const BASE_TITLE = process.env.REACT_APP_TITLE ?? "";
export const Loading: FC<
  PropsWithChildren<{ loading?: boolean; text?: string }>
> = ({ children, loading = true, text = "" }) => {
  return loading ? (
    <div className="load-wrapper">
      <LoadingOutlined className="loading-icon" />
      <h1 className="logo">{BASE_TITLE}</h1>
      <p className="text">{text}</p>
      {/*  正在进入阅文系统，请等待...*/}
    </div>
  ) : (
    <>{children}</>
  );
};

export const Page404 = () => (
  <h1 style={{ display: "flex", alignItems: "center", height:"100vh",justifyContent:"center", textAlign: "center" }}>
      【加载失败】---
      <a onClick={()=>{document.title = '返回'}} style={{marginRight:20,marginLeft:20}}>返回</a>
      <a onClick={()=>{
          location.reload()
      }}>重试</a>
  </h1>
);
